import {Reducer} from 'redux';
import initialState from './state';
import {IReduxAction, IReduxNotificationsState} from '../../@interfaces';
import {
    NOTIFICATIONS_MARK_AS_READ,
    NOTIFICATIONS_NEW_ONE_CREATED,
    NOTIFICATIONS_SET_UNREAD_NUMBER,
    NOTIFICATIONS_TOGGLE_LIST
} from './contants';

const reducer: Reducer = (state: IReduxNotificationsState = initialState, action: IReduxAction): IReduxNotificationsState => {
    switch (action.type) {
        case NOTIFICATIONS_TOGGLE_LIST:
            return {
                ...state,
                listDisplayed: action.payload.listDisplayed != null ?
                    action.payload.listDisplayed :
                    !state.listDisplayed
            };

        case NOTIFICATIONS_MARK_AS_READ:
            return {...state, unreadNumber: Math.max(0, state.unreadNumber - 1)};

        case NOTIFICATIONS_SET_UNREAD_NUMBER:
            return {...state, ...action.payload};

        case NOTIFICATIONS_NEW_ONE_CREATED:
            return {...state, unreadNumber: state.unreadNumber + 1};

        default:
            break;
    }

    return state;
};

export default reducer;
